import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 路由组件懒加载（可选）
const Login = () => import("@/views/Login.vue");
const Layout = () => import("@/views/Layout.vue");
const Statistics = () => import("@/views/Statistics.vue");
const DeptList = () => import("@/views/Dept/List.vue");
const RoleList = () => import("@/views/Role/List.vue");
const Dict = () => import("@/views/set/Dict.vue");
const DictList = () => import("@/views/set/DictList.vue");
const Protocol = () => import("@/views/Config/Protocol.vue");
const Log = () => import("@/views/Config/Log.vue");
const HouseList = () => import("@/views/House/List.vue");
const HouseApproval = () => import("@/views/House/Approval.vue");
const RoomList = () => import("@/views/Room/List.vue");
const RoomApproval = () => import("@/views/Room/Approval.vue");
const CharacterList = () => import("@/views/Character/List.vue");

const routes = [
  {
    path: "/login",
    component: Login,
    meta: { title: "登录" },
  },
    {
    path: "/",
    component: Layout,
    redirect: "/statistics",
    children: [
      { path: "/statistics", component: Statistics, meta: { title: "统计概括" } }, // 空路径 = /home
    ],
  },
  {
    path: "/dept",
    component: Layout,
    redirect: "/dept/list",
    children: [
      {
        path: "list", // ✅ 访问 /dept/list
        component: DeptList,
        meta: { title: "部门列表" },
      },
    ],
  },
  {
    path: "/character",
    component: Layout,
    redirect: "/character/list",
    meta: { title: "角色管理" },
    children: [
      { path: "list", component: CharacterList, meta: { title: "角色列表" } },
    ],
  },
  {
    path: "/role",
    component: Layout,
    redirect: "/role/list",
    meta: { title: "账号管理" },
    children: [
      { path: "list", component: RoleList, meta: { title: "账号列表" } },
    ],
  },
  {
    path: "/config",
    component: Layout,
    redirect: "/config/protocol",
    meta: { title: "配置权限" },
    children: [
      // { path: "dict", component: Dict, meta: { title: "字典项" } },
      // { path: "dictList", component: DictList, meta: { title: "字典表" } },
      { path: "protocol", component: Protocol, meta: { title: "协议" } },
      { path: "log", component: Log, meta: { title: "操作日志" } },
    ],
  },
  {
    path: "/set",
    component: Layout,
    redirect: "/set/dict",
    meta: { title: "配置权限" },
    children: [
      { path: "dict", component: Dict, meta: { title: "字典项" } },
      { path: "dictList", component: DictList, meta: { title: "字典表" } },
    ],
  },
  {
    path: "/house",
    component: Layout,
    redirect: "/house/list",
    meta: { title: "房源管理" },
    children: [
      { path: "list", component: HouseList, meta: { title: "房源列表" } },
      {
        path: "approval",
        component: HouseApproval,
        meta: { title: "删除审批" },
      },
    ],
  },
  {
    path: "/room",
    component: Layout,
    redirect: "/room/list",
    meta: { title: "房屋管理" },
    children: [
      { path: "list", component: RoomList, meta: { title: "房屋列表" } },
      {
        path: "approval",
        component: RoomApproval,
        meta: { title: "删除审批" },
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

// 路由守卫：未登录跳转登录页

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // 1. 如果用户已登录
  if (token) {
    // 已登录，不允许再访问登录页，重定向到首页
    if (to.path === "/login") {
      next("/"); // 或者 /home, /dept/list 等主页面
      return;
    }
    // 放行
    next();
  }
  // 2. 如果用户未登录
  else {
    // 未登录，只允许访问登录页，其他页面全部跳转到登录
    if (to.path === "/login") {
      next(); // 放行登录页
    } else {
      next("/login"); // 重定向到登录页
    }
  }
});

export default router;
